import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import styled from '@xstyled/styled-components';
import Image from 'next/image';
import { getColor, getSize } from '@lib/common';
import { SpeakingMaxAttempts, SpeakingMinAnswerDuration, TimeUnit } from '@module/form';
import { resolveSpeakingLabel } from '../speaking-labels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledBadgesWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ", ";\n  margin: ", " 0 ", ";\n\n  &.compact {\n    margin: 0;\n  }\n"])), getSize('padding8'), getSize('padding8'), getSize('padding16'));
var StyledBadgeItem = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid ", ";\n  border-radius: 999px;\n  background-color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n  color: ", ";\n  line-height: 1.2;\n\n  strong {\n    font-weight: 700;\n    color: ", ";\n  }\n"])), getColor('shapeBorder'), getColor('fillBgWhite'), getSize('typo14'), getColor('contentBody'), getColor('contentHeading'));
var StyledAttemptsNumber = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  color: ", ";\n"])), function (_ref) {
  var $isZero = _ref.$isZero;
  return $isZero ? getColor('errorActive') : 'inherit';
});
export var SpeakingSettingsBadgesComponent = function SpeakingSettingsBadgesComponent(_ref2) {
  var settings = _ref2.settings,
      label = _ref2.label,
      currentAttempts = _ref2.currentAttempts,
      _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'preview' : _ref2$mode,
      _ref2$isAnswerMode = _ref2.isAnswerMode,
      isAnswerMode = _ref2$isAnswerMode === void 0 ? false : _ref2$isAnswerMode,
      _ref2$attemptsBeforeM = _ref2.attemptsBeforeMinimum,
      attemptsBeforeMinimum = _ref2$attemptsBeforeM === void 0 ? false : _ref2$attemptsBeforeM;

  if (!settings) {
    return null;
  }

  var resolvedLabel = resolveSpeakingLabel(label);
  var isUnlimitedAttempts = SpeakingMaxAttempts.isUnlimited(settings.maxAttempts);
  var isNoMinimumDuration = SpeakingMinAnswerDuration.isUnlimited(settings.minAnswerDuration);
  var preparation = TimeUnit.formatLabel(settings.preparationTime, settings.preparationTimeUnit);
  var speaking = TimeUnit.formatLabel(settings.speakingTime, settings.speakingTimeUnit);
  var minimum = isNoMinimumDuration ? resolvedLabel.noRequirement : TimeUnit.formatLabel(settings.minAnswerDuration, settings.minAnswerDurationUnit);
  var maxAttempts = settings.maxAttempts;
  var usedAttempts = currentAttempts !== null && currentAttempts !== void 0 ? currentAttempts : 0;
  var remainingAttempts = currentAttempts === undefined ? maxAttempts : Math.max(0, maxAttempts - currentAttempts);

  var minimumBadge = /*#__PURE__*/_jsxs(StyledBadgeItem, {
    children: [/*#__PURE__*/_jsx(Image, {
      src: "/icons/check-badge.svg",
      width: 16,
      height: 16,
      alt: ""
    }), /*#__PURE__*/_jsxs("span", {
      children: [resolvedLabel.minimum, ":"]
    }), /*#__PURE__*/_jsx("strong", {
      children: minimum
    })]
  });

  var attemptsBadge = /*#__PURE__*/_jsxs(StyledBadgeItem, {
    children: [/*#__PURE__*/_jsx(Image, {
      src: "/icons/refresh.svg",
      width: 16,
      height: 16,
      alt: ""
    }), mode === 'grading' ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        children: [resolvedLabel.usedAttempts, ":"]
      }), /*#__PURE__*/_jsx("strong", {
        children: isUnlimitedAttempts ? "".concat(usedAttempts, " ").concat(resolvedLabel.turnsUnit) : "".concat(usedAttempts, "/").concat(maxAttempts, " ").concat(resolvedLabel.turnsUnit)
      })]
    }) : isAnswerMode ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        children: [resolvedLabel.remainingAttempts, ":"]
      }), /*#__PURE__*/_jsx("strong", {
        children: !isUnlimitedAttempts && remainingAttempts <= 0 ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(StyledAttemptsNumber, {
            $isZero: true,
            children: "0"
          }), "/", maxAttempts]
        }) : isUnlimitedAttempts ? '∞' : "".concat(remainingAttempts, "/").concat(maxAttempts)
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        children: [resolvedLabel.maxAttempts, ":"]
      }), /*#__PURE__*/_jsx("strong", {
        children: isUnlimitedAttempts ? '∞' : maxAttempts
      })]
    })]
  });

  return /*#__PURE__*/_jsxs(StyledBadgesWrapper, {
    className: isAnswerMode || mode === 'grading' ? 'compact' : undefined,
    children: [/*#__PURE__*/_jsxs(StyledBadgeItem, {
      children: [/*#__PURE__*/_jsx(Image, {
        src: "/icons/clock.svg",
        width: 16,
        height: 16,
        alt: ""
      }), /*#__PURE__*/_jsxs("span", {
        children: [resolvedLabel.preparation, ":"]
      }), /*#__PURE__*/_jsx("strong", {
        children: preparation
      })]
    }), /*#__PURE__*/_jsxs(StyledBadgeItem, {
      children: [/*#__PURE__*/_jsx(Image, {
        src: "/icons/timer.svg",
        width: 16,
        height: 16,
        alt: ""
      }), /*#__PURE__*/_jsxs("span", {
        children: [resolvedLabel.answer, ":"]
      }), /*#__PURE__*/_jsx("strong", {
        children: speaking
      })]
    }), attemptsBeforeMinimum ? attemptsBadge : minimumBadge, attemptsBeforeMinimum ? minimumBadge : attemptsBadge]
  });
};